/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsUserReference,
    ElementsUserReferenceFromJSON,
    ElementsUserReferenceFromJSONTyped,
    ElementsUserReferenceToJSON,
    LDAPServerReference,
    LDAPServerReferenceFromJSON,
    LDAPServerReferenceFromJSONTyped,
    LDAPServerReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ElementsGroupDetailPartialUpdate
 */
export interface ElementsGroupDetailPartialUpdate {
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsGroupDetailPartialUpdate
     */
    permissions?: Array<string>;
    /**
     * 
     * @type {Array<ElementsUserReference>}
     * @memberof ElementsGroupDetailPartialUpdate
     */
    members?: Array<ElementsUserReference>;
    /**
     * 
     * @type {LDAPServerReference}
     * @memberof ElementsGroupDetailPartialUpdate
     */
    ldap?: LDAPServerReference;
    /**
     * 
     * @type {string}
     * @memberof ElementsGroupDetailPartialUpdate
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ElementsGroupDetailPartialUpdate
     */
    ldapDn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsGroupDetailPartialUpdate
     */
    unixGroupname?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ElementsGroupDetailPartialUpdate
     */
    gid?: number | null;
}

export function ElementsGroupDetailPartialUpdateFromJSON(json: any): ElementsGroupDetailPartialUpdate {
    return ElementsGroupDetailPartialUpdateFromJSONTyped(json, false);
}

export function ElementsGroupDetailPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElementsGroupDetailPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'permissions': !exists(json, 'permissions') ? undefined : json['permissions'],
        'members': !exists(json, 'members') ? undefined : ((json['members'] as Array<any>).map(ElementsUserReferenceFromJSON)),
        'ldap': !exists(json, 'ldap') ? undefined : LDAPServerReferenceFromJSON(json['ldap']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'ldapDn': !exists(json, 'ldap_dn') ? undefined : json['ldap_dn'],
        'unixGroupname': !exists(json, 'unix_groupname') ? undefined : json['unix_groupname'],
        'gid': !exists(json, 'gid') ? undefined : json['gid'],
    };
}

export function ElementsGroupDetailPartialUpdateToJSON(value?: ElementsGroupDetailPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'permissions': value.permissions,
        'members': value.members === undefined ? undefined : ((value.members as Array<any>).map(ElementsUserReferenceToJSON)),
        'ldap': LDAPServerReferenceToJSON(value.ldap),
        'name': value.name,
        'ldap_dn': value.ldapDn,
        'unix_groupname': value.unixGroupname,
        'gid': value.gid,
    };
}


